export const backendEnTranslations = {
  'cost center belongs to another organisation':
    'Cost center belongs to another organisation',
}
